import http from "./http";

export function listBeneficiaries(params = {}) {
  return http.get("/beneficiaries", { params });
}

export function listMemberBeneficiaries(memberId, params = {}) {
  return http.get(`/members/${memberId}/beneficiaries`, {
    params,
  });
}

export function getBeneficiary(id) {
  return http.get(`/beneficiaries/${id}`);
}

export function createBeneficiary(payload) {
  return http.post("/beneficiaries", payload);
}

export function updateBeneficiary(id, payload) {
  return http.put(`/beneficiaries/${id}`, payload);
}

export function toggleBeneficiaryActive(id, isActive) {
  return http.patch(`/beneficiaries/${id}/status`, {
    is_active: Boolean(isActive),
  });
}

export function deleteBeneficiary(id) {
  return http.delete(`/beneficiaries/${id}`);
}